import React, { useMemo } from 'react';
import NestedFilterPanel from '@client/components/search/NestedFilterPanel';
import FilterSection from '@client/components/search/FilterSection';
import Reseeding from '@client/feature/treatment/components/Search/Filters/Reseeding';
import Agronomic from '@client/feature/treatment/components/Search/Filters/Agronomic';
import Health from '@client/feature/treatment/components/Search/Filters/Health';
import Environment from '@client/feature/treatment/components/Search/Filters/Environment';
import {
  ALL_FILTER_CONFIGS,
  RESEEDING_FILTER_CONFIGS,
  AGRONOMIC_FILTER_CONFIGS,
  HERBICIDE_FILTER_CONFIGS,
  HEALTH_FILTER_CONFIGS,
  ENVIRONMENT_FILTER_CONFIGS,
  ENEMIES_FILTER_CONFIG,
  DOCUMENT_TYPE,
} from '@client/feature/treatment/config/filterConfigs';
import UpIcon from '../../../../../../img/collapse-icon-up.svg';

const ExtraFilters = ({ filters, onFilterChange, aggregations, filterLabels, searchData }) => {
  const countSelections = (filterKeys) => {
    return filterKeys.reduce((count, key) => {
      const value = filters[key];
      if (Array.isArray(value) && value.length > 0) {
        return count + value.length;
      }
      return count;
    }, 0);
  };

  const isHerbicide = useMemo(() => {
    const label =
      searchData?.selectionLabels?.treatment_type?.[0]?.label?.toLowerCase() || '';
    return label.includes('herbicide') || label.includes('défanant');
  }, [searchData?.selectionLabels?.treatment_type]);

  const sections = [
    {
      key: '0',
      labelKey: 'treatment-search|Agronomic',
      Component: Agronomic,
      filterKeys: AGRONOMIC_FILTER_CONFIGS.map((c) => c.key),
    },
    {
      key: '1',
      labelKey: 'treatment-search|Reseeding',
      Component: Reseeding,
      filterKeys: RESEEDING_FILTER_CONFIGS.map((c) => c.key),
    },
    {
      key: '2',
      labelKey: 'treatment-search|Health',
      Component: Health,
      filterKeys: HEALTH_FILTER_CONFIGS.map((c) => c.key),
    },
    {
      key: '3',
      labelKey: 'treatment-search|Environment',
      Component: Environment,
      filterKeys: ENVIRONMENT_FILTER_CONFIGS.map((c) => c.key),
    },
  ];

  const expandIcon = ({ isActive }) => (
    <img
      src={UpIcon}
      alt="Toggle"
      style={{
        width: '24px',
        height: '24px',
        transition: 'transform 0.3s ease',
        transform: isActive ? 'rotate(0deg)' : 'rotate(180deg)',
      }}
    />
  );

  return (
    <div className="space-y-6">
      {/* Enemies Filter + Herbicide Filters (side by side when herbicide) */}
      <div className={`w-full ${isHerbicide ? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4' : ''}`}>
        <FilterSection
          filterConfigs={[ENEMIES_FILTER_CONFIG]}
          allFilterConfigs={ALL_FILTER_CONFIGS}
          filters={filters}
          onFilterChange={onFilterChange}
          document={DOCUMENT_TYPE}
          aggregations={aggregations}
          filterLabels={filterLabels}
          className={isHerbicide ? '' : 'w-[300px]'}
        />

        {isHerbicide && HERBICIDE_FILTER_CONFIGS.map((config) => (
          <FilterSection
            key={config.key}
            filterConfigs={[config]}
            allFilterConfigs={ALL_FILTER_CONFIGS}
            filters={filters}
            onFilterChange={onFilterChange}
            document={DOCUMENT_TYPE}
            aggregations={aggregations}
            filterLabels={filterLabels}
            className=""
          />
        ))}
      </div>

      {/* Collapsible Filter Panels */}
      <NestedFilterPanel
        sections={sections}
        filters={filters}
        onFilterChange={onFilterChange}
        expandIcon={expandIcon}
        countSelections={countSelections}
        aggregations={aggregations}
        filterLabels={filterLabels}
      />
    </div>
  );
};

export default ExtraFilters;
